








































































































import store from '@/app/store';
import { useKeycloak } from '@/modules/auth/composables/keycloak';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { BreedingRhombusSpinner } from 'epic-spinners';
import { UserRoles } from '../constants';
import { Icon } from '@iconify/vue2';
import { useNavigationItems } from '../composable';

export default defineComponent({
    name: 'Home',
    metaInfo: {
        title: 'Home',
    },
    components: { BreedingRhombusSpinner, Icon },
    setup(props, { root }) {
        const open = ref(false);
        const isLoggingIn = ref(false);

        const user = computed(() => store.state.auth.user);

        const isModelModerator = computed(
            () => isAuthenticated.value && store.getters.auth.hasRole(UserRoles.ModelModerator),
        );
        const isAdmin = computed(() => isAuthenticated.value && store.getters.auth.hasRole(UserRoles.Admin));
        const { navigation } = useNavigationItems(user, isModelModerator, isAdmin);

        const { isEnabled, register, login: keycloakLogin, isAuthenticated: keycloakAuthenticated } = useKeycloak();
        const isAuthenticated = computed(() => keycloakAuthenticated());
        const isKeycloakEnabled = isEnabled();

        const login = async () => {
            isLoggingIn.value = true;
            try {
                await keycloakLogin();
            } catch (e: any) {
                (root as any).$toastr.e(e.message, 'Error');
            } finally {
                isLoggingIn.value = false;
            }
        };

        if (
            isEnabled() &&
            document.location.hash.length > 0 &&
            document.location.hash.match(/^#.*code=[a-zA-Z0-9]*/g)
        ) {
            root.$router.push({ name: 'home', hash: '' });
        }

        return { open, isAuthenticated, login, isKeycloakEnabled, register, isLoggingIn, navigation };
    },
});
